import { render, staticRenderFns } from "./speed_test_list.vue?vue&type=template&id=d5d89b88&"
import script from "./speed_test_list.vue?vue&type=script&lang=js&"
export * from "./speed_test_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports